import type { FaireProductEntity } from "../../entity_types/product";

export const p_y45gdwugnt: FaireProductEntity = {
  token: "p_y45gdwugnt",
  type: "product",
  name: "2\" x 3\" Fragile This Side Up Stickers - Roll of 500",
  brandToken: "b_ajaj2rm3ar",
  brandName: "Store Supply Warehouse",
  imageUrl: "https://cdn.faire.com/fastly/e102741274d230f7031a8ebb97de7f404f64d70ff8ff12df43877b46a6edc1fb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/63aecea8a57c1201125ec06e53f7923dc3714380fea3710869192614169e0476.jpeg",
    "https://cdn.faire.com/fastly/6b763f1b21971c44b3ec09d0b7e782aba0cfc76230a531c04cc2df9caa73a365.jpeg",
    "https://cdn.faire.com/fastly/53072b86624e4ada73407e00af57e937a2e5044a8089f658f023cd0ebe9f157a.jpeg"
  ],
  priceDollars: 14.95,
  description: "Highly visible 2\" x 3\" Fragile This Side Up labels that flag fragile contents and show the correct upright orientation for cartons during handling and transit.\n\n- Size: 2\" W x 3\" H\n- Self-adhesive backing applies quickly to boxes and cartons\n- Quantity: 500 stickers per roll\n\nKeep a roll at the packing station for outgoing orders with fragile merchandise.",
  tags: [],
  msrpDollars: 22.43,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:05:04.460Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
